
// import organizationSerivce from '@/modules/Organization/service.js'

export default {
    namespaced: true,
    state: {
        modules: {},
        location: null,
        employeeList: [],
        timeClockUsers: {
            admins: [],
            employees: [],
        },
        selectedRange: 'thisWeek',
        currentOrganization: {},
    },
    getters: {
        getLocation(state) {
            return state.location;
        },
        getSelectedRange(state) {
            return state.selectedRange;
        },
        employeeList(state) {
            return state.employeeList;
        },
        getTimeClockUsers(state) {
            return state.timeClockUsers;
        },
    },
    actions: {
        setLocation({ commit }, payload) {
            commit('setLocation', payload);
        },
        setSelectedRange({ commit }, payload) {
            commit('setSelectedRange', payload);
        },
        setEmployeeList({ commit }, payload) {
            commit('setEmployeeList', payload);
        },
        setTimeClockAdmins({ commit }, payload) {
            commit('setTimeClockAdmins', payload);
        },
        setTimeClockEmployees({ commit }, payload) {
            commit('setTimeClockEmployees', payload);
        }
    },
    mutations: {
        setLocation(state, payload) {
            state.location = payload;
        },
        setSelectedRange(state, payload) {
            state.selectedRange = payload;
        },
        setEmployeeList(state, payload) {
            state.employeeList = payload;
        },
        setTimeClockAdmins(state, payload) {
            state.timeClockUsers.admins = payload;
        },
        setTimeClockEmployees(state, payload) {
            state.timeClockUsers.employees = payload;
        },
        initOrganization(state, payload) {
            state.currentOrganization = payload
          },
    }
}